import { Box, BoxProps } from '@material-ui/core';
import { PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

interface IDemoContentWrapperProps extends BoxProps {
  title?: string
}

export const DemoContentWrapper = ({ title, children, ...rest }: PropsWithChildren<IDemoContentWrapperProps>) => {
  const theme = useTheme()
  
  return (
    <Box width="100%" padding="2rem 0" borderBottom={`1px solid ${theme.colors.supplementary1}`} {...rest}>
      {title && <h3>{title}</h3>}
      <Box display="grid" gridGap="1rem">
        {children}
      </Box>
    </Box>
  )
}